import types from "./types";

const initialState = {
  activeFilter: null,
  activeFilterState: null,
  customFilters: []
}

const incidentReducer = (state = initialState, action) => {
  switch (action.type)
  {
    case types.SET_ACTIVE_FILTER:
      return {
        ...state,
        activeFilter: action.payload.activeFilter,
        activeFilterState: action.payload.activeFilterState
      }
    case types.ADD_NEW_FILTER:
      return {
        ...state,
       customFilters: [...state.customFilters, action.payload.newFilter]
      }
      case types.SAVE_FILTER_EDIT:
        return {
          ...state,
         customFilters: [...state.customFilters.filter(customFilter => customFilter.filterGuid !== action.payload.filter.filterGuid), action.payload.filter]
        }

      case types.REMOVE_FILTER:
        return {
          ...state,
           customFilters: [...state.customFilters.filter(customFilter => customFilter !== action.payload.filterToRemove)]
        }
        case types.NUKE_FILTERS:
          return {
            ...state,
             customFilters: []
          }


    default:
      return state;
  }
}

export default incidentReducer;
